const {h, render, Component} = require('preact');
const {route} = require('preact-router')
const TitleView = require('../../views/refund_form/title')
const RefundReasonOptionsView = require('../../views/refund_form/refund_reason_options')
const DescriptionView = require('../../views/refund_form/description')
const RefundPaymentOptionsView = require('../../views/refund_form/refund_payment_options')
const AcknowledgeView = require('../../views/refund_form/acknowledge')
const OrderView = require('../../views/refund_form/order')
const TicketCreationButtonView = require('../../views/refund_form/ticket_creation_button')
const SpinnerView = require('../../views/common/spinner')
const ErrorView = require('../main/error')
const SupportAPIHelper = require('../../../../../support/frontend/helpers/API')
const Helper = require('../../../helper')


const REFUND_CATG = "About my purchase"
const REFUND_SUB_CATG = "I wish to cancel my purchase"

class RefundRequestForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: null,
      orderDetails: null,
      isOrderDetailsLoading: true,
      orderCallFailure: false
    };
    this.toggleTicketCreationButtonClass = this.toggleTicketCreationButtonClass.bind(this);
    this.onSubmitClick = this.onSubmitClick.bind(this);
  }

  componentDidMount() {
    let orderId = this.props.order_id
    this.setState({'orderId': orderId});
    if (orderId) {
      let ORDER = `${Groupon.Utils.getConfigFromDom().SUPPORTBASEURL}/orders/${orderId}`
      let errorCb = () => {
        this.setState({orderDetails: null, 'isOrderDetailsLoading': false, 'orderCallFailure': true});
      }
      let successCb = (response) => {
        if (response) {
          this.setState({orderDetails: response, 'isOrderDetailsLoading': false});
        }
      }
      SupportAPIHelper.get(ORDER, null, successCb, errorCb, false);
    }
  }

  checkAcknowledge() {
    let id = document.getElementById('refund-message');
    if (id) {
      return id.checked;
    }
    return false;
  }

  getRefundReasonCode() {
    let e = document.getElementById("refund-reasons");
    let reasonCode = e.options[e.selectedIndex].value;
    return 'reason_' + reasonCode;
  }

  validateRefundForm() {
    if (this.checkAcknowledge() && this.getRefundReasonCode() != "")
      return true;
    return false
  }

  toggleTicketCreationButtonClass() {
    if (this.validateRefundForm())
      this.enableSubmitButton()
    else
      this.disableSubmitButton()
  }

  enableSubmitButton() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.removeAttribute("disabled");
  }

  disableSubmitButton() {
    var submitButton = document.getElementsByClassName('submit-button btn')[0];
    if (submitButton)
      submitButton.setAttribute('disabled', true)
  }

  getUserLoggedIn() {
    return JSON.parse(Groupon.Utils.getConfigFromDom().user);
  }
  isRefundAfterCoolingOff() {
    return this.state.orderDetails.metadata.isRefundAfterCoolingOff;
  }
  checkCreditRefundOption() {
    let disableSRTRefundOptions = this.state.orderDetails.disableSRTRefundOptions;
    let isPaymentGrouponCredits = this.state.orderDetails.isPaymentGrouponCredits;
    let enableSRTCashAfterCooling = this.state.orderDetails.enableSRTCashAfterCooling;
    if(this.isRefundAfterCoolingOff() && !enableSRTCashAfterCooling){
      return true;
    }
    let refundOptionId = document.querySelector('input[name="refund-options"]:checked')
    if(refundOptionId) {
      let refundOptionValue = refundOptionId.value
      if (refundOptionValue == 'Credits')
        return true
    }
    if(isPaymentGrouponCredits && disableSRTRefundOptions){
      return true
    }
   return false
  }

  constructTicketDescription() {
    let description = "";
    description += `\n${I18n.translate('js.modules.web_2018.srt_groupon_bucks_checkbox')} : ${this.checkCreditRefundOption()}\n`;
    description += `\n${I18n.translate('js.modules.web_2018.srt_consent_checkbox')} : ${this.checkAcknowledge()}\n`;
    description += `\n${I18n.translate('js.modules.web_2018.srt_reason_selection')} : ${this.getRefundReasonCode()}\n`;
    let optionalDescription = document.getElementById("refund-text-area").value
    if (!_.isEmpty(optionalDescription))
      description += `\n${I18n.translate('js.modules.support.whatson')}\n${optionalDescription}`
    return description;
  }

  collectTicketData() {
    let order = this.state.orderDetails;
    let data = {}
    let user = this.getUserLoggedIn();
    if (user) {
      data.user_name = user.firstName;
      data.user_email = user.email;
    }
    data.order_id = this.props.order_id;
    data.deal_id = order.deal.id;
    data.description = this.constructTicketDescription()
    data.reason_id = REFUND_SUB_CATG
    data.category_id = REFUND_CATG
    data.reason_text = REFUND_SUB_CATG
    data.refund_reason_id = this.getRefundReasonCode();
    data.is_refund_eligible = true;
    data.credit_refund_check_box_selected = this.checkCreditRefundOption();
    data.is_refund_after_cooling_off = this.isRefundAfterCoolingOff()
    data['g-recaptcha-response'] = false;
    return data;
  }

  renderSuccess() {
    route(`/customer_support/web/thank_you?channel=refund`);
  }

  renderError() {
    route(`/customer_support/web/error`);
  }

  submitFormForTicketCreation(data) {
    Helper.createTicket(data, this.renderSuccess, this.renderError)
  }

  onSubmitClick() {
    this.disableSubmitButton();
    if (this.validateRefundForm()) {
      let formData = this.collectTicketData();
      this.submitFormForTicketCreation(formData)
    }
  }

  render() {
    if (this.state.isOrderDetailsLoading)
      return (<SpinnerView/>)
    if (this.state.orderCallFailure)
      return (<ErrorView/>)
    if (this.state.orderDetails) {
      return (
        <section className="main row cs_support_header" id="contact-us-body-content">
          <div className="twelve columns">
            <section className="module">
              <div className="module-body contact-us">
                <div className="row">
                  <div id="help-wizard" class="help-wizard" style="display: block;">
                    <div class="help-wizard-content">
                      <div>
                        <div class="twelve columns refund-padding">
                          <div class="row">
                            <div class="six columns first-section">
                              <TitleView/>
                              <RefundReasonOptionsView metadata={this.state.orderDetails.metadata}
                                                       handleClick={this.toggleTicketCreationButtonClass}/>
                              <DescriptionView/>
                              <RefundPaymentOptionsView order={this.state.orderDetails}/>
                              <AcknowledgeView handleClick={this.toggleTicketCreationButtonClass}
                                               order={this.state.orderDetails}/>
                              <TicketCreationButtonView onSubmitClick={this.onSubmitClick}/>
                            </div>
                            <div class="five columns order-section">
                              <OrderView order={this.state.orderDetails}/>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </section>

      )
    }
  }
}

module.exports = RefundRequestForm
